import { render, staticRenderFns } from "./NewClaim.vue?vue&type=template&id=559331b2&scoped=true&"
import script from "./NewClaim.vue?vue&type=script&lang=js&"
export * from "./NewClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559331b2",
  null
  
)

export default component.exports